var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
/* eslint-disable no-empty-pattern */
import React, { useState, useEffect } from 'react';
import { CustomAutoCompleteField } from '../../../commons/CustomAutoCompleteField';
import { CustomFormikNumberField } from '../../../commons/CustomFormikNumberField';
import { TextWrapper, Wrapper } from './CampaignSelection.Styles';
export var CampaignSelection = function (_a) {
    var campaign = _a.campaign, campaigns = _a.campaigns, getOneCampaign = _a.getOneCampaign, values = _a.values, errors = _a.errors, setFieldValue = _a.setFieldValue, registerField = _a.registerField, setCallingMode = _a.setCallingMode, callingMode = _a.callingMode;
    var _b = useState(''), mode = _b[0], setMode = _b[1];
    var _c = useState([
        {
            label: 'Power',
            value: 'power'
        },
        {
            label: 'Agentless',
            value: 'agentless'
        },
    ]), modeOptions = _c[0], setModeOptions = _c[1];
    // useEffect(() => {
    //   setMode(values?.campaignMode);
    //   if (mode === 'power') registerField('concurrentCallsOverride', false);
    //   else if (mode === 'agentless')
    //     registerField('concurrentCallsOverride', true);
    // }, [values?.campaignMode]);
    useEffect(function () {
        setMode(mode);
        setCallingMode(mode);
    }, [mode]);
    var defaultPacing = {
        clearPacing: 'no',
        initialCpaMode: 'none',
        initialCpa: 0,
        initialDuration: 0,
        abaIncrement: 0,
        cpaModifier: 0,
        abaCalculation: 'none',
        abaTargetRate: 0
    };
    return (React.createElement(Wrapper, null,
        React.createElement(TextWrapper, null,
            React.createElement(CustomAutoCompleteField, { options: (campaigns === null || campaigns === void 0 ? void 0 : campaigns.map(function (_a) {
                    var id = _a.id, CampaignName = _a.CampaignName;
                    return ({
                        label: "" + CampaignName,
                        value: id
                    });
                })) || [], name: 'campaign', label: 'Campaign', placeholder: 'Please Select', onHandleChange: function (value) {
                    var selectedCampaign = value;
                    getOneCampaign(selectedCampaign).then(function (data) {
                        var campaignData = data.value.data.campaign;
                        setMode(campaignData.BaseConfig.CallingMode);
                        setCallingMode(campaignData.BaseConfig.CallingMode);
                        if (value) {
                            if (campaignData.BaseConfig.CallingMode === 'power') {
                                var pacing_1 = __assign({}, campaignData.Pacing);
                                var sequences = __spreadArrays(values.sequences).map(function (seq) { return (__assign(__assign({}, seq), { pacing: {
                                        clearPacing: 'yes',
                                        initialCpaMode: pacing_1.InitialCPAMode,
                                        initialCpa: pacing_1.InitialCPA,
                                        initialDuration: pacing_1.InitialDuration,
                                        abaIncrement: pacing_1.AbaIncrement,
                                        cpaModifier: pacing_1.CpaModifier,
                                        abaCalculation: pacing_1.AbaCalculation,
                                        abaTargetRate: pacing_1.AbaTargetRate
                                    } })); });
                                setFieldValue('sequences', sequences);
                            }
                        }
                    });
                }, fullWidth: true })),
        React.createElement(TextWrapper, null,
            React.createElement(CustomFormikNumberField, { name: 'scheduleLoops', label: 'Schedule Loops', min: 0, fullWidth: true })),
        callingMode === 'agentless' ? (React.createElement(TextWrapper, null,
            React.createElement(CustomFormikNumberField, { name: 'concurrentCallsOverride', label: 'Concurrent Calls Override', min: 0, fullWidth: true, clear: true }))) : null));
};
CampaignSelection.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=CampaignSelection.js.map